export class Match {
  teams: { teamNumber }[];
  numberOfGames: number;
  score1: number = 0;
  score2: number = 0;
  subMatch1: Match = null;
  subMatch2: Match = null;
  level: number;

  constructor(teams, numberOfGames, level = 0) {
    this.teams = teams;
    this.numberOfGames = numberOfGames[0];
    this.level = level;
    if (teams.length > 2) {
      this.subMatch1 = new Match(
        teams.slice(0, teams.length / 2),
        numberOfGames.slice(1, numberOfGames.length),
        level + 1
      );
      this.subMatch2 = new Match(
        teams.slice(teams.length / 2, teams.length),
        numberOfGames.slice(1, numberOfGames.length),
        level + 1
      );
    }
  }

  get id(): string {
    return this.level + ":" + this.teams[0].teamNumber;
  }

  get winner(): any {
    if (this.score1 >= this.score2) return this.team1;
    return this.team2;
  }

  get team1(): any {
    if (this.hasSubMatches) return this.subMatch1.winner;
    return this.teams[0];
  }

  get team2(): any {
    if (this.hasSubMatches) return this.subMatch2.winner;
    return this.teams[1];
  }

  get hasSubMatches(): boolean {
    return this.subMatch1 != null && this.subMatch2 != null;
  }

  get allMatches(): Match[] {
    const allMatches: Match[] = [this];
    if (this.hasSubMatches) return allMatches.concat(this.subMatch1.allMatches).concat(this.subMatch2.allMatches);
    return allMatches;
  }

  fullLevel(level: number, arr: Match[] = []): Match[] {
    if (level === this.level) arr.push(this);
    if (level > this.level) {
      this.subMatch1.fullLevel(level, arr);
      this.subMatch2.fullLevel(level, arr);
    }
    return arr;
  }

  get height(): number {
    if (this.hasSubMatches) return this.subMatch1.height + 1;
    return 0;
  }

  get maxScore(): number {
    return Math.ceil(this.numberOfGames / 2);
  }

  get isValid(): boolean {
    if (this.level === 0) return this.score1 !== this.score2;
    return (this.score1 === this.maxScore) !== (this.score2 === this.maxScore);
  }
}
